import script from "./InputSearchPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSearchPrimary.vue?vue&type=script&setup=true&lang=js"

import "./InputSearchPrimary.vue?vue&type=style&index=0&id=46b47a10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b47a10"]])

export default __exports__